import { Grid } from '@material-ui/core'
import styled from 'styled-components'

export const GridStyled = styled(Grid)`
  ${({ mt, mr, mb, ml }) => `
    margin: ${mt}px ${mr}px ${mb}px ${ml}px
  `}
`
